import axios from "axios";
import { ONE_DRIVE_API } from "@/api/drives.constants";
import { getMSGraphTokenWithinTeams } from "../services/token";
import { MS_FILE_DATA } from "../types/msGraph";
import { networkErrorMessaging } from "./utils";

let graphToken = null;
export async function getMSGraphTokenInit() {
    graphToken = await getMSGraphTokenWithinTeams();
}

const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(conf => {
    conf.headers = {
        Authorization: `Bearer ${graphToken}`,
        ...conf.headers,
    };
    return conf;
})
axiosInstance.interceptors.response.use((res => res.data), (error = {}) => {
    const { response } = error;
    let msgKey = 'NetworkError';
    if (response) {
        const { status, data } = response;
        switch (status) {
            case 401:
                msgKey = 'DrivesListDlg.TokenExpire';
                break;
            case 403:
                if (data.error.message === 'You do not have access to create this personal site or you do not have a valid license') {
                    msgKey = 'Error.NoLicense';
                } else if (data.error.code === "accessDenied") {
                    msgKey = 'Error.PermissionDenied';
                }
                break;
            case 404:
                msgKey = 'FileNotExist';
                break;
            default:
                break;
        }
    }
    networkErrorMessaging(msgKey);
    throw error;
});

export async function fetchSiteResourceBypath(hostname: string, relativePath: string) {
    return axiosInstance.get(`${ONE_DRIVE_API.BASEURL}/sites/${hostname}:/${relativePath}`) as any as { id: string };
}

export async function fetchDocumentLibForSite(siteId: string) {
    return axiosInstance.get(`${ONE_DRIVE_API.BASEURL}/sites/${siteId}/drive`) as any as { id: string };
}

const queries = '?select=id,name,@microsoft.graph.downloadUrl,lastModifiedDateTime,size';
export async function fetchDriveItemResourceByItemPath(driveId: string, itemPath: string) {
    return axiosInstance.get(`${ONE_DRIVE_API.BASEURL}/drives/${driveId}/root:/${itemPath}${queries}`) as any as MS_FILE_DATA;
}

export async function fetchDriveItemResourceByItemId(driveId: string, itemId: string) {
    return axiosInstance.get(`${ONE_DRIVE_API.BASEURL}/drives/${driveId}/items/${itemId}${queries}`) as any as MS_FILE_DATA;
}

export async function fetchDriveItemResourceByUserId(userId: string, relativePath: string) {
    return axiosInstance.get(`${ONE_DRIVE_API.BASEURL}/users/${userId}/drive/root:/${relativePath}${queries}`) as any as MS_FILE_DATA;
}

const createUploadSessionData = {
    item: {
        '@microsoft.graph.conflictBehavior': 'replace',
    },
};
const contentTypeConf = {
    headers: {
        'Content-Type': 'application/json',
    }
}
export async function createUploadSessionByDriveId(driveId: string, itemId: string) {
    return axiosInstance.post(`${ONE_DRIVE_API.BASEURL}/drives/${driveId}/items/${itemId}/createUploadSession`,
        createUploadSessionData,
    );
}
export async function createUploadSessionBySiteId(siteId: string, fileId: string) {
    return axiosInstance.post(`${ONE_DRIVE_API.BASEURL}/sites/${siteId}/drive/items/${fileId}/createUploadSession`,
        createUploadSessionData,
        contentTypeConf);
}
export async function createUploadSessionByUserId(userId: string, itemId: string) {
    return axiosInstance.post(`${ONE_DRIVE_API.BASEURL}/users/${userId}/drive/items/${itemId}/createUploadSession`,
        createUploadSessionData,
        contentTypeConf);
}

// https://learn.microsoft.com/en-us/graph/api/driveitem-createuploadsession?view=graph-rest-1.0
export async function uploadFile(uploadUrl: string, file: File) {
    return axiosInstance.put(uploadUrl, file, {
        headers: {
            'Content-Range': `bytes 0-${(file.size - 1)}/${file.size}`,
        },
    })
}
